import path from 'path'

// Where a service lands in the target project. Shared by the id validator (which has to know whether an id
// is already taken while the user is still typing it) and the scaffolder (which writes there).

export const SERVICES_DIRECTORY = 'services'

export function servicesDirectory(projectRoot: string = process.cwd()): string {
  return path.join(projectRoot, SERVICES_DIRECTORY)
}

export function serviceDirectory(serviceId: string, projectRoot: string = process.cwd()): string {
  return path.join(servicesDirectory(projectRoot), serviceId)
}
